import { render, staticRenderFns } from "./CalendarEventsPerDay.vue?vue&type=template&id=2bdf94c0&scoped=true&"
import script from "./CalendarEventsPerDay.vue?vue&type=script&lang=js&"
export * from "./CalendarEventsPerDay.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventsPerDay.vue?vue&type=style&index=0&id=2bdf94c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf94c0",
  null
  
)

export default component.exports